import { useToastStore, type ToastType } from '../store/toastStore';

const DEFAULT_DURATIONS: Record<ToastType, number> = {
  success: 4000,
  warning: 4000,
  info: 4000,
  error: 7000,
};

function show(type: ToastType, message: string, duration?: number): string {
  return useToastStore.getState().push({
    type,
    message,
    duration: duration ?? DEFAULT_DURATIONS[type],
  });
}

export function useToast() {
  return {
    success: (msg: string, duration?: number) => show('success', msg, duration),
    error: (msg: string, duration?: number) => show('error', msg, duration),
    warning: (msg: string, duration?: number) => show('warning', msg, duration),
    info: (msg: string, duration?: number) => show('info', msg, duration),
    dismiss: (id: string) => useToastStore.getState().dismiss(id),
    clear: () => useToastStore.getState().clear(),
  };
}

// Standalone variants for use outside React components (e.g. axios interceptor).
export const toast = {
  success: (msg: string, duration?: number) => show('success', msg, duration),
  error: (msg: string, duration?: number) => show('error', msg, duration),
  warning: (msg: string, duration?: number) => show('warning', msg, duration),
  info: (msg: string, duration?: number) => show('info', msg, duration),
};
